<template>
  <material-card class="pt-2" full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-google-classroom </v-icon>
          {{ $t("bigbluebutton_published_files", { domain: serverData.domain }) }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="publishedFileList" :headers="publishedFilesHeader" :loading="loading" item-key="recordID"
      :search="search" show-select v-model="selectedRows" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getPublishedFiles">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary"
              v-show="hasPermission('virtual_machine_recording_delete')"  @click="showDeletePublishedFilesDialog">
                <v-icon medium>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("bbb_delete_published_files") }}
            </span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="showGetNDaysDialog"
                v-show="meetingId == '' && hasPermission('virtual_machine_recording_delete')">
                <v-icon medium>mdi-delete-clock-outline</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("bbb_delete_published_files_n_days") }}
            </span>
          </v-tooltip> -->

        </v-toolbar>
      </template>
      <!-- custom columns -->
      <template v-slot:[`item.playback.format.url`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on">
              <v-icon color="primary" medium @click="openPlayBack(item)">mdi-television-play</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("bbb_show_playback") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on" :disabled="!hasPermission('virtual_machine_recording_delete')" >
              <v-icon color="primary" medium @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("bbb_delete_published_file") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.startTime`]="{ item }">
        <span>{{ new Date(parseInt(item.startTime)).toLocaleString() }}</span>
      </template>
      <template v-slot:[`item.endTime`]="{ item }">
        <span>{{ new Date(parseInt(item.endTime)).toLocaleString() }}</span>
      </template>
    </v-data-table>
    <template #actions>

    </template>

    <AskDialog :visible="deletePublishedFilesDialog" yes no :loading="deleteLoading" @yesClick="deletePublishedFiles"
      @noClick="closeDeletePublishedFilesDialog" :text="deletePublishedFilesDialogText"></AskDialog>
    <AskDialog :visible="deletePublishedFilesNDaysDialog" yes no :loading="deleteLoading"
      @yesClick="deletePublishedFilesNDays" @noClick="closeDeletePublishedFilesNDaysDialog"
      :text="deletePublishedFilesNDaysDialogText"></AskDialog>
    <v-dialog v-model="getNDaysDialog" width="500">
      <v-card>
        <v-card-title>
          {{ $t('bbb_published_files_delete_n_days') }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="nDays" type="number" width="150"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <app-btn v-text="$t('delete')" text @click="showDeletePublishedFilesNDaysDialog">
          </app-btn>
          <v-spacer></v-spacer>
          <app-btn v-text="$t('cancel')" text @click="closeGetNDaysDialog">
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </material-card>
</template>
<script>
import permissions from '../mixins/permissions';

export default {
  name: "BBBPublishedFiles",
  props: {
    visible: Boolean,
    serverData: {
      type: Object,
      default: {}
    },
    meetingId: {
      type: String,
      default: ''
    }
  },
  computed: {

  },
  mixins:[permissions],
  data() {
    return {

      publishedFilesHeader: [
        { value: "name", text: this.$t("meeting_name") },
        { value: "state", text: this.$t("state") },
        { value: "meetingID", text: this.$t("meeting_id") },
        { value: "playback.format.url", text: this.$t("playback") },
        { value: "playback.format.length", text: this.$t("duration") },
        { value: "recordID", text: this.$t("record_id") },
        { value: "startTime", text: this.$t("start_time") },
        { value: "endTime", text: this.$t("end_time") },
        { value: "delete", text: this.$t("delete") },
      ],
      publishedFileList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: [],
      selectedRows: [],
      deletePublishedFilesDialog: false,
      deleteLoading: false,
      deletePublishedFilesDialogText: '',
      deletePublishedFilesNDaysDialogText: '',
      deletePublishedFilesNDaysDialog: false,
      nDays: 0,
      getNDaysDialog: false
    };
  },
  watch: {
    options: {
      handler() {
        this.getPublishedFiles();
      },
      deep: true,
    },
  },
  methods: {
    getPublishedFiles() {
      this.loading = true;
      let payload = {};
      if (this.meetingId != '')
        payload['meeting_id'] = this.meetingId;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/" + this.serverData.id + "/recording",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
        params: payload
      })
        .then((response) => {
          let data = response.data.data;
          if (data == undefined) return;
          this.publishedFileList = (Array.isArray(data) ? data : [{ ...data }]);
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    deletePublishedFilesNDays() {
      this.rebuildLoading = true;
      let recordIds = [];
      this.selectedRows.forEach(record => {
        recordIds.push({ recordId: record.meeting_id });
      })

      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/deleteOldRecording/" + this.serverData.id,
        method: "POST",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
        data: { recordIds }
      })
        .then((response) => {
          this.$toasted.success(this.$t('bbb_published_files_delete_n_days_dialog_success'))
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.rebuildLoading = false;
        });
    },
    deletePublishedFiles() {

      this.deleteLoading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/removepublished/" + this.serverData.id,
        method: "POST",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {
          this.$toasted.success(this.$t('bbb_published_files_delete_successfully'))
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.deleteLoading = false;
        });
    },
    deleteItem(item) {
      this.selectedRows = [item]
      this.showDeletePublishedFilesDialog();
    },
    showDeletePublishedFilesDialog() {
      if (this.selectedRows.length == 0) {
        this.$toasted.error(this.$t('select_a_row'))
        return;
      }
      this.deletePublishedFilesDialogText = this.$t('bbb_published_files_delete_dialog_text');
      this.deletePublishedFilesDialog = true;
    },
    closeDeletePublishedFilesDialog() {
      this.deletePublishedFilesDialogText = '';
      this.deletePublishedFilesDialog = false;
    }
    ,
    showGetNDaysDialog() {
      this.getNDaysDialog = true;
    },
    closeGetNDaysDialog() {
      this.getNDaysDialog = false;
      this.nDays = 0;
    },
    showDeletePublishedFilesNDaysDialog() {
      if (this.nDays == 0) {
        this.$toasted.error(this.$t('n_days_greater_zero'));
        return;
      }
      this.deletePublishedFilesNDaysDialogText = this.$t('bbb_published_files_delete_n_days_dialog_text', { n: this.nDays });
      this.closeGetNDaysDialog();
      this.deletePublishedFilesNDaysDialog = true;
    },
    closeDeletePublishedFilesNDaysDialog() {
      this.deletePublishedFilesNDaysDialog = false;
    },
    openPlayBack(item) {
      window.open(item.playback.format.url, "_blank")
    }
    ,
    close() {
      this.$emit('close')
    }
  },
  mounted() {
    this.getPublishedFiles();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  